interface IProps {
  handleFeedback: (event: any, score: number) => void;
  selectedValue: number | '';
}

const Score = ({ handleFeedback, selectedValue }: IProps): JSX.Element => {
  const scoreColours = [
    '#EA5E62',
    '#ED6F5C',
    '#F07F55',
    '#F3904F',
    '#F6A048',
    '#F9B142',
    '#FCC13B',
    '#FFD235',
    '#BFCB6C',
    '#9EC888',
    '#7EC4A3',
  ];

  const getScoreBackgroundColour = (score: number) => {
    if (selectedValue !== '') {
      if (selectedValue === score) {
        return scoreColours[score];
      }
      return '#CCCCCC';
    }
    return scoreColours[score];
  };

  const scoreButtons = () => {
    const items: React.ReactElement[] = [];
    for (let i = 10; i >= 0; i -= 1) {
      items.push(
        <button
          key={`nps-score-button-${i}`}
          className={`button is-primary m-1 is-fullwidth nps-score-button is-rounded${
            selectedValue === i ? ` is-selected` : ``
          }`}
          style={{
            background: getScoreBackgroundColour(i),
          }}
          type="button"
          onClick={e => handleFeedback(e, i)}>
          {i}
        </button>,
      );
    }
    return items;
  };

  return (
    <div className="nps-score">
      <div className="is-hidden-touch mb-1 nps-score-labels-desktop">
        <span className="is-font-brand is-size-6">No, not at all</span>
        <span className="is-font-brand is-size-6">Yes, definitely</span>
      </div>
      <div className="nps-score-buttons is-size-6">
        <div className="is-font-brand is-hidden-desktop is-size-6 is-hidden-desktop has-text-centered">
          Yes, definitely
        </div>
        {scoreButtons()}
        <div className="is-font-brand is-hidden-desktop is-size-6 is-hidden-desktop has-text-centered">
          No, not at all
        </div>
      </div>
    </div>
  );
};

export default Score;
